<div class="map-actions">
  <a
    class="light-btn-link light-color-primary imp back-to-map-link"
    (click)="backToList()"
    (keydown.enter)="backToList()"
    tabindex="0"
    role="link"
    i18n="@@maphotelsBackToList"
    >Back to list view
    <span class="visuallyhidden">&nbsp; for hotel results</span>
  </a>
  @if (hotelAvailabilityService.fetching | async) {
    <div i18n="@@loadingHotels">Loading...</div>
  }
</div>
<div class="hotel-map-container">
  <div class="hotel-map-search-container" [hidden]="!directionsPanelOpen">
    <div class="flex-column-container hotel-map-search-inputs">
      <div class="flex-row-container flex-row-container--between directions-header">
        <div class="directions-mode-toggle">
          <button
            type="button"
            class="directions-mode-icon-btn"
            aria-label="Select driving transport mode"
            i18n-aria-label
            [attr.aria-pressed]="directionsMode === 'DRIVING'"
            (click)="setupAddressSearch('DRIVING')"
            [ngClass]="{ 'selected-directions-mode': directionsMode === 'DRIVING' }"
          >
            <fa-icon [icon]="faCar" aria-hidden="true"></fa-icon>
          </button>
          <button
            type="button"
            class="directions-mode-icon-btn"
            aria-label="Select walking transport mode"
            i18n-aria-label
            [attr.aria-pressed]="directionsMode === 'WALKING'"
            (click)="setupAddressSearch('WALKING')"
            [ngClass]="{ 'selected-directions-mode': directionsMode === 'WALKING' }"
          >
            <fa-icon [icon]="faPersonWalking" aria-hidden="true"></fa-icon>
          </button>
        </div>
        <button
          type="button"
          class="close"
          title="Close Hotel Map Directions"
          id="hotel_map_directions_close"
          aria-label="Close Hotel Map Directions"
          i18n-aria-label
          (click)="clearHotelDirections()"
        >
          <span aria-hidden="true">
            <i class="ico-cancel modal_exit_cross"></i>
          </span>
        </button>
      </div>
      <p class="directions-instruction" i18n="@@mapHotelsDirectionsInstruction">
        Get directions to or from a location
      </p>
      <div class="directions-locations">
        <div class="directions-inputs">
          <input
            #fromInput
            autocorrect="off"
            autocapitalize="off"
            spellcheck="off"
            type="text"
            class="form-control directions-input"
            id="hotelmap_from_input"
            placeholder="Enter a location"
            i18n-placeholder="@@mapHotelsEnterLocation"
            aria-label="From location"
            i18n-aria-label="@@mapHotelsFromLabel"
          />
          <input
            #toInput
            autocorrect="off"
            autocapitalize="off"
            spellcheck="off"
            type="text"
            class="form-control directions-input"
            id="hotelmap_to_input"
            placeholder="Enter a location"
            i18n-placeholder="@@mapHotelsEnterLocation"
            aria-label="To location"
            i18n-aria-label="@@mapHotelsToLabel"
          />
        </div>
        <button
          type="button"
          class="swap-directions-btn"
          title="Swap locations"
          i18n-title="@@mapHotelsSwapLocations"
          [disabled]="!directionsOrigin && !directionsDestination"
          (click)="swapDirectionsLocations()"
        >
          <fa-icon [icon]="faArrowsUpDown" aria-hidden="true"></fa-icon>
          <span class="visuallyhidden" i18n="@@mapHotelsSwapLocations">Swap locations</span>
        </button>
      </div>
    </div>
    <div class="directions-panel">
      <div #directionsPanel></div>
      @if (directionsOrigin && directionsDestination && directionsURL) {
        <a
          i18n="@@mapHotelViewGoogleMaps"
          target="_blank"
          class="directions-download"
          [href]="directionsURL"
        >
          Click here to view in Google Maps
        </a>
      }
    </div>
  </div>
  @if (!error) {
    <google-map height="600px" width="100%" [options]="mapOptions" #map>
      <deprecated-map-marker-clusterer [styles]="clusterStyles">
        @for (location of locations; track location) {
          <map-marker
            #marker="mapMarker"
            [position]="location"
            [title]="location.title"
            [icon]="location.iconUrl | async"
            (mapClick)="markerClicked(location)"
            (mapMouseover)="openInfoWindow(marker, infoWindow)"
          >
            <map-info-window #infoWindow="mapInfoWindow">
              <div class="hotel-snazzy-window">
                <div class="flex-row-container">
                  <img
                    [src]="location.ThumbUrl"
                    class="hotel-item-image"
                    alt="image of {{ location.title ? location.title : 'hotel' }}"
                  />
                  <div class="flex-column-container snazzy-window-details">
                    <p class="hotel-item-name" [innerHTML]="location.title"></p>
                    @if (location.stars) {
                      <div>
                        <p class="stars_container">
                          @if (location.stars >= 0.5) {
                            <i
                              class="ico-star"
                              [ngClass]="{ half_star: location.stars === 0.5 }"
                              aria-hidden="true"
                            ></i>
                          }
                          @if (location.stars >= 1.5) {
                            <i
                              class="ico-star"
                              [ngClass]="{ half_star: location.stars === 1.5 }"
                              aria-hidden="true"
                            ></i>
                          }
                          @if (location.stars >= 2.5) {
                            <i
                              class="ico-star"
                              [ngClass]="{ half_star: location.stars === 2.5 }"
                              aria-hidden="true"
                            ></i>
                          }
                          @if (location.stars >= 3.5) {
                            <i
                              class="ico-star"
                              [ngClass]="{ half_star: location.stars === 3.5 }"
                              aria-hidden="true"
                            ></i>
                          }
                          @if (location.stars >= 4.5) {
                            <i
                              class="ico-star"
                              [ngClass]="{ half_star: location.stars === 4.5 }"
                              aria-hidden="true"
                            ></i>
                          }
                          <span class="sr-only"
                            >{{ location.stars }}&nbsp;<span i18n="@@mapHotelsStars"
                              >stars</span
                            ></span
                          >
                        </p>
                      </div>
                    }
                    @if (location.price) {
                      <div class="flex-row-container hotel-snazzy-price">
                        <span class="hotel-item-labels" i18n="@@mapHotelsFrom">From</span>
                        <span class="hotel-item-price">{{ location.price | number: '1.2-2' }}</span>
                        <span class="hotel-item-price-type">{{ location.currency }} </span>
                      </div>
                    }
                    <div class="flex-row-container flex-row-container--right map_options">
                      <button
                        i18n="@@mapHotelDetails"
                        class="map_hotel_details"
                        (click)="openDetails(location)"
                      >
                        Hotel Details
                      </button>
                      <button
                        i18n="@@mapHotelDirections"
                        class="map_hotel_directions"
                        (click)="openDirections(location)"
                      >
                        Directions
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </map-info-window>
          </map-marker>
        }
      </deprecated-map-marker-clusterer>
      <map-marker
        [position]="referencePoint"
        [title]="'Search Location'"
        [icon]="locationPinURL"
        id="search-location-marker"
        i18n-title="@@hotelMapSearchLocation"
      >
      </map-marker>
      <core-map-content (onMapLoad)="loadAPIWrapper($event)"></core-map-content>
      @if (directionsResults$ | async; as directionsResults) {
        <map-directions-renderer
          [directions]="directionsResults"
          [options]="{
            panel: directionsPanel,
            suppressMarkers: true
          }"
        />
      }
    </google-map>
  }
</div>

@if (error) {
  <div class="no_results_message background-container-background">
    <h2 class="no_results_message_heading">
      <i class="ico-map-1 no_results_icon"></i>
      <span i18n="@@maphotelsMapNotAvail">Map not available!</span>
    </h2>
  </div>
}
